import { Stack, Typography } from '@mui/material';

import { sx } from './styles';
import { ViewGlobalNotificationProps } from './types';
import { RenderHtml } from '@/components/RenderHtml';

export const ViewGlobalNotification = ({
  notification,
}: ViewGlobalNotificationProps) => {
  return (
    <Stack sx={sx.container}>
      <Typography sx={sx.subject}>{notification?.subject}</Typography>
      <RenderHtml sx={sx.description}>{notification?.description}</RenderHtml>
    </Stack>
  );
};
